import { Box, Center } from '@chakra-ui/react';
import { YapamarLogo } from 'src/components/atoms/YapamarLogo';
import { AuthUIContainer } from 'src/components/templates/AuthUIContainer';

export const AuthLandingPage = () => {
  return (
    <Box bg="text.darkBlue.950" minH="100vh">
      <Box
        as="header"
        w="100%"
        h="64px"
        borderBottom="1px solid #2C3E50"
        px={{ base: 4, md: 24, lg: 32 }}
        display="flex"
        alignItems="center">
        <YapamarLogo clickable={false} />
      </Box>
      <Center pt={{ base: 12, md: 20 }}>
        <Box
          bg="surface.panel"
          borderRadius="8px"
          w="100%"
          maxW="480px"
          mx={4}
          p={6}>
          <AuthUIContainer />
        </Box>
      </Center>
    </Box>
  );
};
